import { all, put, select, takeLatest } from 'redux-saga/effects';
import { sampleEvents } from './sampleData';
import { getEvents } from './selectors';
import { AppActions } from './slice';
import { filterEvents, getUniqueCategories } from './utils';

export function* startAppSaga() {
  // Do some initial setup and load the data
  const events = sampleEvents;
  const categories = getUniqueCategories(events);
  const filteredEvents = filterEvents(events, undefined);
  yield put(AppActions.started({ events, categories, filteredEvents }));
}

function* filterChangedSaga(action) {
  const events = yield select(getEvents);
  const filter = action.payload;
  const filteredEvents = filterEvents(events, filter);
  yield put(AppActions.setFilteredEvents(filteredEvents));
}

export default function* appSagaWatcher() {
  yield all([takeLatest(AppActions.startApp, startAppSaga), takeLatest(AppActions.filterChanged, filterChangedSaga)]);
}
